import { render, staticRenderFns } from "./area_select.vue?vue&type=template&id=c0d10f50"
import script from "./area_select.vue?vue&type=script&lang=js"
export * from "./area_select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c0d10f50')) {
      api.createRecord('c0d10f50', component.options)
    } else {
      api.reload('c0d10f50', component.options)
    }
    module.hot.accept("./area_select.vue?vue&type=template&id=c0d10f50", function () {
      api.rerender('c0d10f50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/dms/views/contract/contract/form/sales_area/area_select.vue"
export default component.exports